import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';

// Store
import store from './js/store';

// Components
import Modal from './js/components/Modal';
import OpenApiMap from './js/components/OpenApiMap';
import Wizard from './js/components/Wizard';
// import Editor from '@tinymce/tinymce-vue';
// import 'tinymce/tinymce';
// import 'tinymce/themes/silver/theme';
// import 'tinymce/skins/content/default/';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp({
  components: {
    Modal,
    OpenApiMap,
    Wizard,
    // Editor,
  },
  mixins: mixinArray || [],
  store,
});

app.use(pinia);

app.mount('#app');
